export default "__VITE_ASSET__bn0CboP4__"